import { STEP_LABELS } from '@/features/onboarding/api'
import type { StatusLevel } from '@westhetics/ui'
import type { AdminClinic, RegistrationStatus } from './api'

/** O nome pelo qual a clínica é chamada: o fantasia; sem ele, a razão social (RN-ADM-08). */
export function clinicName(clinic: Pick<AdminClinic, 'legalName' | 'tradeName'>) {
  return clinic.tradeName ?? clinic.legalName
}

/** O status da clínica por extenso (RN-ADM-51, RN-ADM-85): bloqueada, em implantação ou ativa. */
export function clinicStatus(clinic: Pick<AdminClinic, 'status' | 'onboarding'>): {
  level: StatusLevel
  label: string
} {
  if (clinic.status === 'blocked') return { level: 'attention', label: 'Bloqueada' }
  if (!clinic.onboarding.isCompleted) {
    const { doneStepCount, stepCount } = clinic.onboarding
    return { level: 'attention', label: `Em implantação · ${doneStepCount} de ${stepCount}` }
  }
  return { level: 'done', label: 'Ativa' }
}

/** "2 de 4 etapas · falta Procedimentos": o resumo da implantação que o painel recebe. */
export function onboardingSummary(onboarding: AdminClinic['onboarding']) {
  const done = `${onboarding.doneStepCount} de ${onboarding.stepCount} etapas`
  return onboarding.currentStep ? `${done} · falta ${STEP_LABELS[onboarding.currentStep]}` : done
}

/** A situação cadastral do CNPJ na base pública, como aparece na dica do campo. */
export const REGISTRATION_STATUS_LABELS: Record<RegistrationStatus, string> = {
  active: 'ativa',
  suspended: 'suspensa',
  unfit: 'inapta',
  closed: 'baixada',
  void: 'nula',
}
